// extracted by mini-css-extract-plugin
var _1 = "assets-js-GalleryPB-components-SeoHeaderWithBreadcrumb-SeoHeaderWithBreadcrumb-module__breadcrumbs__Sfku2";
var _2 = "assets-js-GalleryPB-components-SeoHeaderWithBreadcrumb-SeoHeaderWithBreadcrumb-module__content__l0KOy";
var _3 = "assets-js-GalleryPB-components-SeoHeaderWithBreadcrumb-SeoHeaderWithBreadcrumb-module__copyWrapper__wSAIQ";
var _4 = "assets-js-GalleryPB-components-SeoHeaderWithBreadcrumb-SeoHeaderWithBreadcrumb-module__wrapper__okK8_";
export { _1 as "breadcrumbs", _2 as "content", _3 as "copyWrapper", _4 as "wrapper" }
